import { formatMainImage } from './shopHelper';

const idOf = value => String(value?._id || value || '');

export const resolveProductRecommendations = ({
    recommendations,
    products,
    cartItems,
    sourceProductId,
    limit = 4
}) => {
    const excludedProducts = new Set([
        String(sourceProductId || ''),
        ...(cartItems || []).map(item => idOf(item.prod_id))
    ]);
    const productById = new Map((products || []).map(product => [
        idOf(product),
        product
    ]));
    const resolved = [];

    for (const recommendation of [...(recommendations || [])]
        .sort((a, b) => Number(a.rank) - Number(b.rank))) {
        const productId = idOf(recommendation.product_id);
        if (!productId || excludedProducts.has(productId))
            continue;
        const product = productById.get(productId);
        const variant = product?.prod_variants?.find(item =>
            idOf(item) === idOf(recommendation.variant_id)
        );
        if (!product || !variant)
            continue;

        resolved.push({
            ...recommendation,
            recommendation_rank: recommendation.rank,
            rank: resolved.length + 1,
            product_id: productId,
            variant_id: idOf(variant),
            title: product.title,
            brand: product.brand,
            url: product.url,
            review_summary: product.review_summary,
            variant_title: variant.variant_title,
            barcode: variant.barcode,
            price: variant.price,
            item_promotion: variant.item_promotion || {},
            img: formatMainImage(variant.images || [])
        });
        excludedProducts.add(productId);
        if (resolved.length >= limit)
            break;
    }

    return resolved;
};
